<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Project</legend>
			<div class="form__group">
				<div class="toggle-group">
					<input
                        id="is-opportunity"
                        name="is opportunity"
                        class="toggle"
                        type="radio"
                        :value="true"
                        v-model="formData.isOpportunity"
                        v-validate
                        required
                    />
					<label for="is-opportunity" class="toggle">Yes</label>
					<input
                        id="is-not-opportunity"
                        name="isOpportunity"
                        class="toggle"
                        type="radio"
                        :value="false"
                        v-model="formData.isOpportunity"
                        v-validate
                        required
                    />
					<label for="is-not-opportunity" class="toggle">No</label>
				</div>
				<label class="form__label">Is this an existing opportunity?</label>
				<div class="form__validation">{{ errors.first('isOpportunity') }}</div>
			</div>
			<FormControlOpportunity
                name="opportunity"
                v-model="formData.opportunity"
                label="Select existing opportunity"
                v-if="formData.isOpportunity"
                v-validate="'required'"
            />
			<FormControlUser
                name="lead"
                v-model="formData.lead"
                label="Select lead user"
                v-validate="'required'"
            />
			<FormControlUser
                name="team"
                v-model="formData.team"
                label="Additional users"
                :multiple="true"
                v-validate="'required'"
            />
			<div class="form__group form__group--submit">
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import FormControlUser from '../../Form/Control/FormControlUser';
	import MADDFormStep from './MADDFormStep';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlOpportunity from '../../Form/Control/FormControlOpportunity';

	export default {
		name: 'MADDFormStep1',
		mixins: [MADDFormStep],
		components: {
			FormControlOpportunity,
			ValidationAlert,
			FormControlUser,
		},
		data() {
			return {
				formData: {
					isOpportunity: false,
					opportunity: null,
					lead: null,
					team: [],
				}
			}
		},
	}
</script>
